import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICustomerResponse } from '../models/customer.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * @description Function to get a list of customers
 * 
 * @param {string} [partnerID] optional partnerID
 * 
 * @returns {ICustomerResponse} the api response | error
 */
const GetCustomers = async ( partnerID?: string ): Promise<ICustomerResponse> => {
  try {
    //apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get('/customer', {
      params: {
        wpID: userId,
        partnerID: partnerID
      }
    });
    
    return data;
  } catch (error ) {
    handleRouteError(error, 'Error getting customer data');
    throw(error);
  }
}

export default GetCustomers;